import type { Application } from "@/views/application/application";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
  responseAdapter,
};

function addAuthRequestFields(entity: Application) {
  entity._authRequestFields = ["id", "statusMurn"] as (keyof Application)[];
  return entity;
}
function getInitialData() {
  const result = {} as Application; //TODO: ts
  return addAuthRequestFields(result);
}
/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Application }) {
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Application }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: Application) {
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: Application) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Application) {}
